module.exports = __webpack_public_path__ + "img/upcoming-auction-2.39fab0fe.png";